module.exports = __webpack_public_path__ + "static/neon-abd4b3b0c22e5f90e344801306005627.png";